module.exports = __webpack_public_path__ + "static/media/iconkongkongruye.3876313d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconkongkongruye.png
// module id = 775
// module chunks = 0